<app-modal-container
  [title]="'Commitment allocation'"
  [buttons]="modalButtons"
  [applyActivated]="checkApplyActivated()"
  (dismissButtonClicked)="close()"
  (closeButtonClicked)="close()"
  (applyButtonClicked)="confirmUpdateFundPerformance()">

<div [formGroup]="fpGroup" class="vertical-container-simple column-gap-0p5">
  <div class="start-start-row-container">
    <app-input
      data-qa="totalCommitment"
      formControlName="totalCommitment"
      class="width-17p5"
      [title]="'Total commitment'"
      [thousandSeparator]="','"
      [separator]="'separator.0'"
      (keyup)="commitmentCount($event.target.value)">
    </app-input>
    <div class="xAxis-whitespace-1"></div>
    <app-input
      data-qa="totalCost"
      formControlName="totalCost"
      class="width-17p5"
      [title]="'Portfolio investment'"
      [thousandSeparator]="','"
      [separator]="'separator.0'"
      [allowNegativeNumbers]="true">
    </app-input>
    <div class="xAxis-whitespace-1"></div>
    <app-input
      data-qa="expectedOpEx"
      formControlName="expectedOpEx"
      class="width-17p5"
      [title]="'Total expected OpEx (till liquidation)'"
      [additionalClass]="opExClass.type"
      [bottomText]="opExClass.bottomText"
      [thousandSeparator]="','"
      [separator]="'separator.0'"
      [allowNegativeNumbers]="true"
      [suffix]="'%'"
      [suffixText]="(fpGroup.value.totalCommitment ?
        (-fpGroup.value.totalCommitment * fpGroup.value.expectedOpEx / 100).toFixed(0) : '') | numberswitcher:1:0"
      (keyup)="expectedOpExCount($event.target.value)">
    </app-input>
  </div>
  <div class="aligned-row-container row-gap-1">
    <app-input
      data-qa="expectedFutureInv"
      formControlName="expectedFutureInv"
      class="width-17p5"
      [title]="'New investment allocation'"
      [thousandSeparator]="','"
      [separator]="'separator.0'"
      [prefix]="expectedFutureInvPrefix"
      (keyup)="expectedFutureInvCount($event.target.value)">
    </app-input>
    <app-input
      data-qa="allocationCommitment"
      formControlName="allocationCommitment"
      class="unallocated-commitment-header width-20"
      [title]="allocationCommitmentTitle"
      [thousandSeparator]="','"
      [allowNegativeNumbers]="true"
      [separator]="'separator.0'">
    </app-input>
  </div>
</div>
</app-modal-container>
